import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { PadDForm, PadFDFormElement } from '../../../../../api/pushVisit';
import { Actions } from '../../../../../store/actions';
import {
    deleteDyForm,
    updateDyFormPrintConfig,
    upsertDyForm,
} from '../../../../../store/actions/prescriptionPad';
import { GlobalState } from '../../../../../store/reducers';
import {
    getPrescriptionDyForm,
    getPrintConfigs,
} from '../../../../../store/selectors/prescriptionPad';
import DynamicCard from '../../../../common/DynamicCard';
import { getGenieSetting } from '../../../../../store/selectors/session';
import { GenieMemoryConfig } from '../../../../../api/pushGenie';

type ComponentProps = {
    id: string;
    name: string;
};

type Props = ComponentProps & {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    form?: PadDForm;
    isPrintEnabled: boolean;
    genieMemoryConfig?: GenieMemoryConfig;
};

class DynamicSectionCard extends PureComponent<Props> {
    onPrintChange = (isPrintEnabled: boolean): void => {
        const { dispatch, id } = this.props;
        dispatch(updateDyFormPrintConfig(id, isPrintEnabled));
    };

    onUpdate = (name: string, elements?: PadFDFormElement[]): void => {
        const { dispatch, id } = this.props;
        // TODO this needs to be updated in genie as well
        dispatch(upsertDyForm({ id, name, elements }));
    };

    onDelete = (): void => {
        const { dispatch, id } = this.props;
        dispatch(deleteDyForm(id));
    };

    render(): ReactNode {
        const { isPrintEnabled, form, id, name, genieMemoryConfig } = this.props;
        const {customSections} = genieMemoryConfig || {};
        return (
            <DynamicCard
                key={id}
                form={{ id, name: form?.name || name, elements: form?.elements }}
                onUpdate={this.onUpdate}
                isPrintEnabled={isPrintEnabled}
                onPrintChange={this.onPrintChange}
                customSectionsConfig={customSections}
                // onDelete={this.onDelete}
            />
        );
    }
}

export default connect((state: GlobalState, props: ComponentProps) => ({
    form: getPrescriptionDyForm(state).find((t) => t.id === props.id),
    isPrintEnabled: getPrintConfigs(state)?.dyform[props.id] !== false,
    genieMemoryConfig: (() => {
        const config = getGenieSetting(state, 'genieMemoryConfig');
        return typeof config === 'object' && config !== null && !Array.isArray(config)
            ? (config as GenieMemoryConfig)
            : undefined;
    })(),
}))(DynamicSectionCard);
